import script from "./CaseManagersTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CaseManagersTable.vue?vue&type=script&lang=ts&setup=true"

import "./CaseManagersTable.vue?vue&type=style&index=0&id=462f7001&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462f7001"]])

export default __exports__